import { toast } from "react-hot-toast";

export const toastErrorHandler = (e: unknown) => {
  console.error(e);
  toast.error(`Error: ${typeof e === "object" && e !== null && "message" in e ? e.message : e}`);
};
